import { render } from "./DeliveryGuidelinesModal.vue?vue&type=template&id=299643e0"
import script from "./DeliveryGuidelinesModal.vue?vue&type=script&lang=js"
export * from "./DeliveryGuidelinesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__